import { graphql, HttpResponse } from 'msw'
import { type EnrollmentEquityData, type EnrollmentEquitySubmitOutput } from '../../../models'
import { EquitiesSector, InvestmentRiskToleranceCategory } from '../../../models/enrollment/enrollment'

export const getEnrollmentEquityDataMock: EnrollmentEquityData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/equity',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        equitySector: [
          {
            type: EquitiesSector.Healthcare,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 11,
              allowedMinPercent: 1,
              allowedMaxPercent: 21,
            },
          },
          {
            type: EquitiesSector.Consumer,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 17,
              allowedMinPercent: 7,
              allowedMaxPercent: 27,
            },
          },
          {
            type: EquitiesSector.Financial,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 16,
              allowedMinPercent: 6,
              allowedMaxPercent: 26,
            },
          },
          {
            type: EquitiesSector.Technology,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 24,
              allowedMinPercent: 14,
              allowedMaxPercent: 32,
            },
          },
          {
            type: EquitiesSector.Industry,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 15,
              allowedMinPercent: 5,
              allowedMaxPercent: 25,
            },
          },
          {
            type: EquitiesSector.Energy,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 7,
              allowedMinPercent: 0,
              allowedMaxPercent: 17,
            },
          },
          {
            type: EquitiesSector.RealEstate,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 2,
              allowedMinPercent: 0,
              allowedMaxPercent: 12,
            },
          },
          {
            type: EquitiesSector.Media,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 8,
              allowedMinPercent: 0,
              allowedMaxPercent: 18,
            },
          },
        ],
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const submitEnrollmentEquityDataMock: EnrollmentEquitySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/fixed-income',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        equitySector: [
          {
            type: EquitiesSector.Healthcare,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 11,
              allowedMinPercent: 1,
              allowedMaxPercent: 21,
            },
          },
          {
            type: EquitiesSector.Consumer,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 17,
              allowedMinPercent: 7,
              allowedMaxPercent: 27,
            },
          },
          {
            type: EquitiesSector.Financial,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 16,
              allowedMinPercent: 6,
              allowedMaxPercent: 26,
            },
          },
          {
            type: EquitiesSector.Technology,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 24,
              allowedMinPercent: 14,
              allowedMaxPercent: 32,
            },
          },
          {
            type: EquitiesSector.Industry,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 15,
              allowedMinPercent: 5,
              allowedMaxPercent: 25,
            },
          },
          {
            type: EquitiesSector.Energy,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 7,
              allowedMinPercent: 0,
              allowedMaxPercent: 17,
            },
          },
          {
            type: EquitiesSector.RealEstate,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 2,
              allowedMinPercent: 0,
              allowedMaxPercent: 12,
            },
          },
          {
            type: EquitiesSector.Media,
            maxAllocationPercent: 32,
            recommendedRange: {
              recommendedPercent: 8,
              allowedMinPercent: 0,
              allowedMaxPercent: 18,
            },
          },
        ],
      },
    },
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const mockGetEnrollmentEquityData = graphql.mutation('getEnrollmentEquityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentEquityDataMock } })
})

export const mockSubmitEnrollmentEquityData = graphql.mutation('submitEnrollmentEquityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentEquityDataMock } })
})

export const mockEnrollmentEquity = [mockGetEnrollmentEquityData, mockSubmitEnrollmentEquityData]
